import { render } from "./AlarmIndex.vue?vue&type=template&id=69b7e485&ts=true"
import script from "./AlarmIndex.vue?vue&type=script&lang=ts"
export * from "./AlarmIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__